import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import PopoverOnHover from "../elements/PopoverOnHover";

const ReasonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ReasonName = styled.div`
  font-weight: ${props => (props.isNoReason ? "normal" : "bold")};
  color: ${props => (props.isNoReason ? "#999" : "inherit")};
`;

const ReasonComment = styled.div`
  font-size: 0.85em;
  color: #666;
  margin-top: 0.25rem;
`;

const PopoverContent = styled.div`
  padding: 8px 12px;
  max-width: 300px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const EligibilityReasonFormatter = ({ row }) => {
  const isNoReason = !row.eligibilityReason;
  const reasonName = row.eligibilityReason || "No reason specified";
  const reasonComment = row.eligibilityReasonComment;

  if (!!reasonComment && reasonComment !== "") {
    const popoverContent = (
      <PopoverContent>
        <div style={{ fontWeight: "bold", marginBottom: "4px" }}>Eligibility Comment:</div>
        <div>{reasonComment}</div>
      </PopoverContent>
    );

    return (
      <PopoverOnHover content={popoverContent} positions={["right", "left", "top", "bottom"]} align="start">
        {() => (
          <ReasonContainer style={{ cursor: "pointer" }}>
            <ReasonName isNoReason={isNoReason}>{reasonName}</ReasonName>
          </ReasonContainer>
        )}
      </PopoverOnHover>
    );
  }

  // Otherwise, show normally
  return (
    <ReasonContainer>
      <ReasonName isNoReason={isNoReason}>{reasonName}</ReasonName>
    </ReasonContainer>
  );
};

EligibilityReasonFormatter.propTypes = {
  row: PropTypes.object.isRequired
};

export default EligibilityReasonFormatter;
